import { useEffect, useState } from 'react';

import { usePublicSeoConfig } from '../hooks/useSeoConfig';
import { buildFaqPageJsonLd, extractFaqEntries, type FaqEntry } from '../lib/jsonLd';
import { JsonLd } from './JsonLd';

/**
 * FAQPage structured data generated from the rendered FAQ prose
 * (each <h3> is a question, the following siblings are its answer).
 * Mount inside the FAQ page; it reads the DOM once after render.
 */
export function FaqJsonLd() {
  const { data: config } = usePublicSeoConfig();
  const [entries, setEntries] = useState<FaqEntry[]>([]);

  useEffect(() => {
    const root = document.querySelector<HTMLElement>('main') ?? document.body;
    setEntries(extractFaqEntries(root));
  }, []);

  if (!config) return null;
  return <JsonLd data={[buildFaqPageJsonLd(config, entries)]} />;
}
